import React, { memo, Suspense } from 'react';

import { ProgressSpinner } from 'primereact/progressspinner';

import { WebinarRoomContextProvider } from '@src/contexts/webinar';

import { OLoader } from '@src/shared';
import { DrawerController, PageController } from '@src/HOC';

import useWebinarJoin from './useWebinarJoin';
import { WebinarCountDown } from '../WebinarLobby/partials';

import styles from './webinarJoin.module.scss';

const WebinarRoom = React.lazy(() => import('../WebinarRoom'));
const WebinarLobby = React.lazy(() => import('../WebinarLobby'));
const AttendeeLobby = React.lazy(() => import('../AttendeeLobby'));

const WebinarJoin = () => {
  const {
    isAttendee,
    haveActiveTimer,
    isLoading,
    setHaveActiveTimer,
    isWebinarStartedByHost,
    webinarDetails,
    isJoinedRoom,
  } = useWebinarJoin();

  if (isLoading || !webinarDetails) {
    return (
      <div className={styles.spinnerContainer}>
        <ProgressSpinner />
      </div>
    );
  }

  if (haveActiveTimer && !isWebinarStartedByHost) {
    return (
      <WebinarCountDown
        targetTime={new Date(webinarDetails?.startTime || new Date())}
        webinarTitle={webinarDetails?.roomTitle || '(Webinar Title)'}
        onComplete={() => setHaveActiveTimer(false)}
      />
    );
  }

  return (
    <PageController
      ComponentA={
        isAttendee ? (
          <Suspense fallback={<OLoader />}>
            <AttendeeLobby />
          </Suspense>
        ) : (
          <Suspense fallback={<OLoader />}>
            <DrawerController />
            <WebinarLobby />
          </Suspense>
        )
      }
      ComponentB={
        <WebinarRoomContextProvider>
          <Suspense fallback={<OLoader />}>
            <WebinarRoom />
          </Suspense>
        </WebinarRoomContextProvider>
      }
      isLoading={false}
      condition={isJoinedRoom}
    />
  );
};

export default memo(WebinarJoin);
